<div class="app-toast__container">
  <div class="app-toast__header-row" *ngIf="showHeader && title">
    <div class="app-toast__title-wrapper">
      <div *ngIf="showLeftIcon" class="app-toast__icon-wrapper">
        <i class="icons app-toast__icon" [innerHTML]="getLeftIconSvg()" [class.app-toast__icon--spin]="isProcess && tone === 'neutral'"></i>
      </div>
      <div class="app-toast__title">{{ title }}</div>
    </div>
    <button *ngIf="!isProcess" class="app-toast__close-btn" (click)="onClose()" aria-label="Close">
      <i class="icons icon-times" [innerHTML]="getCloseIconSvg()"></i>
    </button>
  </div>
  
  <div *ngIf="showMessage" class="app-toast__message">{{ message }}</div>
</div>
